import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const useTrainingPhases = (memberId) => {
  const { apiClient } = useAuth();
  const [totalPhases, setTotalPhases] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageSize] = useState(12); // 与SingleMemberScheduler.js保持一致

  const calculateTotalPhases = useCallback((totalRecords) => {
    const totalPages = Math.ceil(totalRecords / pageSize);
    return totalRecords > 0 ? totalPages : 1;
  }, [pageSize]);

  const fetchTrainingPhases = useCallback(async () => {
    if (!memberId || !apiClient) {
      setTotalPhases(1);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      // 使用与SingleMemberScheduler.js相同的参数
      const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
      const coach = storedUser.coach || '';
      
      const payload = {
        pageNo: 1,
        pageSize: 99999, // 获取所有数据来计算总数
        babyId: memberId, // 必须包含babyId参数
      };
      
      const resp = await apiClient.post('/sports-server-prod/taller.api.v1/prescription/pageList', payload);
      
      if (resp?.data?.code !== 200) {
        throw new Error(resp?.data?.msg || '获取排课数据失败');
      }
      
      const totalRecords = resp.data.data?.totalRecord || 0;
      const calculatedPhases = calculateTotalPhases(totalRecords);
      
      setTotalPhases(calculatedPhases);
      return { totalRecords, totalPhases: calculatedPhases };
      
    } catch (e) {
      console.error('获取训练阶段数据失败:', e);
      setError(e.message);
      setTotalPhases(1); // 出错时默认为1个阶段
      message.error(e?.message || '获取训练阶段数据失败');
    } finally {
      setLoading(false);
    }
  }, [memberId, apiClient, calculateTotalPhases]);

  // 当memberId变化时重新获取数据
  useEffect(() => {
    fetchTrainingPhases();
  }, [fetchTrainingPhases]);

  return {
    totalPhases,
    loading,
    error,
    fetchTrainingPhases,
    calculateTotalPhases
  };
};

export default useTrainingPhases;